import { createAsyncThunk } from '@reduxjs/toolkit';
import { itemsApi } from '../../../api/services/items.service';
import { setNotification, setErrorNotification } from '../../../app/store/notifications';
import { cartApi } from '../../../api/services/cart.service';

export const getItems = createAsyncThunk(
  'items/getItems',
  async (params: { page?: number; page_size?: number; search?: string; category?: string } | undefined, { dispatch }) => {
    try {
      const items = await Promise.all([itemsApi.getItems(params), cartApi.getCart()]);
      const responseData = items[0].data;
      // Handle both paginated and non-paginated responses
      const allItems = Array.isArray(responseData) ? responseData : responseData.results;
      const { data: cartItemsData } = items[1];

      const newItems = allItems.map((item) => {
        return {
          ...item,
          items: item.items.map((i) => {
            const cartItem = cartItemsData.items.find(
              (cartI) => i?.id === cartI.item?.id
            );
            return {
              ...i,
              verification_item: item.verification_item || null,
              verification_quantity: cartItem?.verification_quantity || 0,
              passport_item: item.passport_item || null,
              passport_quantity: cartItem?.passport_quantity || 0,
              inCart: !!cartItem,
              quantity: cartItem?.quantity || 1,
            };
          }),
        };
      });
      return newItems;
    } catch (error) {
      dispatch(setErrorNotification('Ошибка при загрузке товаров.'));
      console.log(error);
      throw error;
    }
  }
);

export const getItem = createAsyncThunk(
  'items/getItem',
  async ({ id }: { id: number }, { dispatch }) => {
    try {
    const response = await itemsApi.getItem(id);
    return response.data;
  } catch (error) {
    dispatch(setErrorNotification('Ошибка при загрузке товара.'));
    console.log(error);
    throw error;
  }
});

export const updateItem = createAsyncThunk(
  'items/updateItem',
  async (
    { itemId, body }: { itemId: number; body: any },
    { dispatch }
  ) => {
    try {
      const response = await itemsApi.updateItem(itemId, body);
      dispatch(setNotification('Товар успешно обновлен!'));
      return response.data;
    } catch (error) {
      dispatch(setErrorNotification('Ошибка при обновлении товара.'));
      throw error;
    }
  }
);

